var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pending_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    fillRule: "evenodd",
    d: "M2.346 3.19a8.01 8.01 0 0 1 12.111.919A8 8 0 0 1 3.421 15.398l-1.052 1.32a.334.334 0 0 1-.578-.106L.429 12.36a.334.334 0 0 1 .346-.434l4.448.379a.332.332 0 0 1 .233.54l-1.203 1.506a6.682 6.682 0 1 0-2.92-5.507.667.667 0 1 1-1.333 0 8 8 0 0 1 2.346-5.654m5.183.517a.667.667 0 0 1 1.138.472v4h4a.667.667 0 0 1 0 1.333H8a.667.667 0 0 1-.667-.667V4.18c0-.177.07-.347.196-.472",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pending_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .845h16v16H0z"
  })))));
};
export default SvgPending;